<template>
    <Administrative>
        <BreadcrumbsComponent :pages="pages" :is-dashboard="false"/>
        <div class="grid gap-4 grid-cols-9 -mt-4">
            <div class="col-span-4">

                <Table :fields="fields"
                       :items="topics"
                       :canView="true"
                       :empty_message="`Reviewed Topics not found`"
                >
                    <template #topic="{item}">
                        {{ item?.title }}
                    </template>
                    <template #total_reviews="{item}">
                        {{ item.review_students }}
                    </template>
                    <template #rating="{item}">
                        {{ item?.rating_avg }} / 5
                    </template>

                    <template #action="{item}">

                        <inertia-link
                            :href="`${route(`administrative.faculty.view.review-topics`, [faculty.id, branch.id, topic?.id])}?item=${item.id}`">
                            <Button>
                                Students
                            </Button>
                        </inertia-link>
                    </template>


                </Table>
            </div>
            <div class="col-span-5" v-if="item">

                <Table :fields="studentsFields"
                       :items="students"
                       :canView="true"
                       :empty_message="`Students not found`"
                >
                    <template #name="{item}">
                        <div>
                            {{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}
                        </div>
                    </template>
                    <template #rating="{item}">
                        <div>
                            {{ !item?.rating ? '-' : `${item?.rating.toFixed(1)}/5` }}
                        </div>
                    </template>
                    <template #review="{item}">
                        <Button @click="()=>{
                            modelForm.isOpen = true;
                            modelForm.message = item?.review;
                        }" v-if="(item?.review ?? '') !== ''">
                            View
                        </Button>
                        <div v-else>
                            '-'
                        </div>
                    </template>


                </Table>
            </div>
        </div>
        <PopupModel :isButton="false"
                    @submit="modelForm.isOpen=false"
                    @close="modelForm.isOpen=false"
                    heading="Review"
                    v-model="modelForm.isOpen"
                    :description="modelForm.message"/>
    </Administrative>
</template>
<script setup>

import Administrative from "@/Pages/Administrative/Administrative.vue";
import {Link, useForm, usePage} from "@inertiajs/inertia-vue3";
import Table from "@/Components/Table.vue";
import Button from "@/Components/Button.vue";
import {computed} from "vue";
import Page from '@/Components/Page'
import BreadcrumbsComponent from "@/Components/BreadcrumbsComponent.vue";
import PopupModel from "@/Components/PopupModel.vue";

const topics = usePage().props.value.topics ?? [];
const students = usePage().props.value.students ?? [];
const faculty = usePage().props.value?.faculty ?? {};
const branch = usePage().props.value?.branch ?? {};
const topic = usePage().props.value?.topic ?? {};
const item = usePage().props.value?.item ?? null;
const course_years = usePage().props.value.course_years ?? [];
const course_year = usePage().props.value?.course_year ?? null;
const modelForm = useForm({
    isOpen: false,
    message: ''
});

const fields = [
    {'key': 'topic', 'label': 'Topic'},
    {'key': 'rating', 'label': 'rating'},
    {'key': 'total_reviews', 'label': 'Total Review'},
    {'key': 'action', 'label': 'Action'}
];
const studentsFields = [
    {'key': 'name', 'label': 'Student'},
    {'key': 'rating', 'label': 'rating'},
    {'key': 'review', 'label': 'review'},
];
const pages = [
    {name: 'Faculties', href: route('administrative.faculty.list'), current: false},
    {
        name: ` ${faculty.first_name} ${faculty.last_name}`,
        href: route('administrative.faculty.view', faculty.id),
        current: false
    },

    {
        name: `${course_year?.title}-${course_year?.course?.title} `,
        href: `${route(`administrative.faculty.view.review`, [faculty.id, branch.id])}?course=${course_year?.id}`,
        current: false
    },
    {
        name: "Subjects",
        href: item ? route(`administrative.faculty.view.review-topics`, [faculty.id, branch.id, topic.id]) : '',
        current: true
    },
    {name: item?.title ? 'Topics' : '', current: true},
]
</script>
